import { BookingRequest } from '@camp67/model';
import { PriceComputation } from './offerings';

export const initialBookingRequest: BookingRequest = {
  primaryContact: {
    id: 'initial-id',
    name: '',
    email: '',
    phone: '',
    acceptedConditions: false,
  },
  reservation: {
    startDate: '',
    endDate: '',
    guests: {
      adult: 1,
      children: 0,
      details: [],
    },
    rooms: [],
  },
};

export const initialPrice: PriceComputation = {
  nights: 0,
  total: 0,
  totalGst: 0,
  totalWithGst: 0,
  gstPercentage: 0,
  accommodationTotal: 0,
  accommodationGst: 0,
  packageTotal: 0,
  packageGst: 0,
  packageGstPercentage: 0,
  packageItems: [],
};
